<div class="col-md-12 col-12 m-0 p-0 position-fixed cape-header">
  <div class="row m-0 p-0" style="height: 50px;">
    <div class=" col-md-6 col-lg-7 col-10 headerClasss row m-0 p-0">
      <div class="col-md-1 hamburgCustom m-0 d-none"> <span class="capelogo" id="hamId">
          &#9776;</span></div>
      <div class="logoClass">
        <img class="capelogo" src="assets/tcs-em-logo-white.png">
      </div>
      <div class="col headerLabelClass">{{screenName}}</div>
    </div>
    <!-- <div class="col-md-2 col-2 m-0 p-0"></div> -->

    <!-- Mobile layout starts -->
    <div class="col-md-2 col-2 m-0 p-0 hamburgCustom hamburgerBlock d-block d-md-none">
      <button type="button" class="btn hamburgerBtn" (click)="mobileMenu()"><span
          class="capelogo">&#9776;</span></button>
      <div class="row hamburger" id="hamburger">
        <div class="bd-toc-item">
          <ul class="nav bd-sidenav">
            <li (click)="showProfile()">Profile</li>
            <li (click)="doLogOut()">Logout</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Mobile layout ends -->

    <div class="col-md-6 col-lg-5 col-5 p-0 h-100 d-none d-md-block headerLeftMenu">
      <div class="row h-100 px-3">
        <div class="col-md-12 col-12 row px-0">

          <div class="col-lg-5 col-xl-4 col-5">
            <!-- <img type="button" src="assets/search-icon.png" matTooltip="Search"
                [matTooltipPosition]="positionOptionsNew" class="searchbtn1" (click)="search()"> -->
            <!-- <img class="moveMenu col-md-4 m-0 p-0"
                *ngIf="showFilterIcon &&  !(cldDrodown.length>0 ||EnvDropdown.length>0 ||LocDropdown.length>0 ||systemDropdwon.length>0 || tenantDropDown.length>0)"
                (click)="openTopNav()" src="assets/filter.png" matTooltip="Filter"
                [matTooltipPosition]="positionOptionsNew"> -->
            <!-- <img class="moveMenu col-md-4 m-0 p-0"
                *ngIf="showFilterIcon && cldDrodown.length>0 ||EnvDropdown.length>0 ||LocDropdown.length>0 ||systemDropdwon.length>0 || tenantDropDown.length>0"
                (click)="openTopNav()" src="assets/Icon-filter-selected.png"> -->
            <div class="Templatecircle" id="profileScreen" matTooltip="Profile"
              [matTooltipPosition]="positionOptionsNew">
              <span class="Templateinitials">{{initials}}</span>
            </div>
            <img class="logoutIcon" src="assets/logout-icon.png" (click)="doLogOut()" matTooltip="Logout"
              [matTooltipPosition]="positionOptionsNew">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <div class="row m-0 p-0">
    <div class="leftMenuDiv d-none d-sm-block">
      <img *ngIf="showhomeicon" [src]="homeIconImage" alt="" class="leftIconNew" style="cursor: pointer;"
        (click)="showScreen('showHome','Home','Home', 'home')" [matTooltip]="homeIcon"
        [matTooltipPosition]="tooltipPosition" (mouseout)="checkMouseOver('showHome')"
        (mouseover)="mouseOver('./assets/home-icon-hover.png', 'showHome')">

      <img *ngIf="showadminicon" [src]="AdminIconimage" alt="" class="leftIconNew" style="cursor: pointer;"
        (click)="showScreen('showAdmin','Administration','Administration', 'administration')" [matTooltip]="AdminIcon"
        [matTooltipPosition]="tooltipPosition" (mouseout)="checkMouseOver('showAdmin')"
        (mouseover)="mouseOver('./assets/Admin-select.png', 'showAdmin')">
    </div>
    <div class="mainRightContent">
      <div class="row">
        <div class="col-md-12 topNav" id="topNav">
          <div class="row">

          </div>
        </div>
        <div class="row" style="height: 100%;overflow-x: hidden; overflow-y: hidden;padding: 0;margin: 0;">
          <div class="col-md-12 row">
            <div class="col-md-12"></div>
            <div style="padding-left: 0;">
              <!-- <mat-progress-bar  class="col-md-12" mode="indeterminate"></mat-progress-bar> -->
              <div *ngIf="showHome" class="col-md-12 componentCall" style="height: 100%;">
                <app-home></app-home>
              </div>
              <div *ngIf="showAdmin" class="col-md-12 componentCall" style="height: 100%;">
                <app-admin></app-admin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <router-outlet></router-outlet> -->
